import { useToast } from "../hooks/useToast";
import classes from "./Toast.module.scss";

const Toast = () => {
  const { toast, removeToast } = useToast();

  if (!toast) return null;

  return (
    <div className={`${classes.toastContainer} ${classes[toast.type]}`}>
      <p className={classes.message}>{toast.message}</p>
      <button
        className={classes.closeButton}
        onClick={removeToast}
        aria-label="Close toast"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
